const moment = require('moment');

angular
  .module('app')
  .controller('AppCtrl', ($scope, $translate, $rootScope, $resource, $http, $window, $cookies, $route, $location, AuthService, envService) => {
    const languages = ['en', 'ko', 'ja', 'th'];
    let savedLang = null;
    try {
      savedLang = $window.localStorage.getItem('omgAdminLang');
    } catch (err) {
      savedLang = null;
    }
    // Default EN for OMG admin (browser KO was showing Korean keys / UI by accident).
    if (languages.indexOf(savedLang) === -1) {
      savedLang = 'en';
    }
    $scope.pageLoading = true;
    $translate.use(savedLang);
    $scope.locale = savedLang;
    moment.locale(savedLang === 'jp' ? 'ja' : savedLang);
    const ready = $translate.onReady && $translate.onReady();
    if (ready && ready.then) {
      ready.then(() => { $scope.pageLoading = false; }, () => { $scope.pageLoading = false; });
    } else {
      $scope.pageLoading = false;
    }
    $scope.$on('$routeChangeStart', () => { $scope.pageLoading = true; });
    $scope.$on('$routeChangeSuccess', () => { $scope.pageLoading = false; });
    $scope.$on('$routeChangeError', () => { $scope.pageLoading = false; });
    if (AuthService.isAuthenticated()) {
      AuthService.validateAuthenticationIfNeeded();
      try {
        $scope.loginMember = JSON.parse($cookies.get('user'));
        if ($location.path() === '') {
          if ($scope.loginMember.LEVEL < 99) {
            $location.path('/washes/count');
          } else {
            $location.path('/members');
          }
        }
      } catch (err) {
        console.log(err);
        $cookies.remove('token');
        $cookies.remove('user');
        $scope.$emit('app.LoginStatusChangedEvent');
      }
    } else {
      $scope.loginMember = null;
      $location.path('/login');
    }
    $scope.isLoginMenu = function isLoginMenu() {
      const path = $location.path();
      if (path === '/login') {
        return true;
      }
      return false;
    };
    $scope.setLang = function setLang(code) {
      if (languages.indexOf(code) === -1) {
        return;
      }
      $scope.pageLoading = true;
      const pending = $translate.use(code);
      $scope.locale = code;
      moment.locale(code === 'jp' ? 'ja' : code);
      const finish = () => { $scope.pageLoading = false; };
      if (pending && pending.then) {
        pending.then(finish, finish);
      } else {
        finish();
      }
      try {
        $window.localStorage.setItem('omgAdminLang', code);
      } catch (err) {
        console.log(err);
      }
    };
    $scope.doLogout = function doLogout() {
      $cookies.remove('token');
      $cookies.remove('user');
      $scope.$emit('app.LoginStatusChangedEvent');
    };

    $scope.reloadPage = function reloadPage() {
      window.location.reload();
    };

    $scope.$on('app.LoginStatusChangedEvent', () => {
      if (AuthService.isAuthenticated()) {
        $scope.loginMember = JSON.parse($cookies.get('user'));
      } else {
        $scope.loginMember = null;
        $location.path('/login');
      }
    });

    $scope.alertNotAvailable = function alertNotAvailable() {
      alert($translate.instant('서비스 준비중입니다.'));
    };

    $scope.moveToWashHistory = (user) => {
      jQuery('#modal-user-view').removeClass('fade');
      jQuery('#modal-user-view').modal('hide');
      $location.path(`/member/${user.ID}/wash/history`);
    };
    $scope.registBlacklist = (user) => {
      const comment = $window.prompt($translate.instant('블랙리스트 등록 사유를 입력해주세요.'));
      $resource(`${envService.read('apiUrl')}/admin/user/blacklist/payonsite`).save({ TB_USER_ID: user.ID, COMMENT: comment }).$promise
        .then(() => {
          alert($translate.instant('등록되었습니다.'));
          jQuery('#modal-user-view').modal('hide');
        })
        .catch((err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
    };
    $scope.unregistBlacklist = (user) => {
      $resource(`${envService.read('apiUrl')}/admin/user/blacklist/payonsite/${user.ID}`).delete().$promise
        .then(() => {
          alert($translate.instant('해제되었습니다.'));
          jQuery('#modal-user-view').modal('hide');
        })
        .catch((err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
    };

    const apiUrl = () => envService.read('apiUrl');
    const alertApiErr = (err) => {
      if (err && err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    };

    $scope.gNewPoint = { PRICE: '' };
    $scope.gNewCoupon = { CODE: '' };
    $scope.gCoupons = [];
    $scope.gPercentCoupons = [];
    $scope.gEditCouponForm = { ID: null, CODE: '', PRICE: '', ENDDATE: '' };

    $scope.gAddPoint = (user) => {
      $rootScope.profileUser = user;
      $scope.gNewPoint = { PRICE: '' };
      jQuery('#modal-user-view').modal('hide');
      jQuery('#modal-g-point').modal('show');
    };
    $scope.gAddPointSubmit = () => {
      const delta = parseInt($scope.gNewPoint.PRICE, 10);
      if ($scope.gNewPoint.PRICE === '' || Number.isNaN(delta) || delta === 0) {
        alert($translate.instant('포인트를 입력해주세요.'));
        return;
      }
      $resource(`${apiUrl()}/admin/users/${$rootScope.profileUser.ID}/mileage/${delta}`).save({}, () => {
        alert($translate.instant('포인트가 수정되었습니다.'));
        $rootScope.profileUser.MILEAGE = parseInt($rootScope.profileUser.MILEAGE, 10) + delta;
        jQuery('#modal-g-point').modal('hide');
        jQuery('#modal-user-view').modal('show');
      }, alertApiErr);
    };

    $scope.gViewCoupon = (user) => {
      $rootScope.profileUser = user;
      $resource(`${apiUrl()}/admin/users/${user.ID}/coupons`).get((data) => {
        $scope.gCoupons = data.coupons || [];
        $scope.gPercentCoupons = data.percent_coupons || [];
        jQuery('#modal-user-view').modal('hide');
        jQuery('#modal-g-coupon').modal('show');
      }, alertApiErr);
    };
    $scope.gAddCoupon = (user) => {
      $rootScope.profileUser = user;
      $scope.gNewCoupon = { CODE: '' };
      jQuery('#modal-user-view').modal('hide');
      jQuery('#modal-g-coupon').modal('hide');
      jQuery('#modal-g-add-coupon').modal('show');
    };
    $scope.gAddCouponSubmit = () => {
      if (!$scope.gNewCoupon.CODE) {
        alert($translate.instant('할인쿠폰 정보를 입력해 주세요'));
        return;
      }
      $resource(`${apiUrl()}/admin/users/${$rootScope.profileUser.ID}/coupon/${$scope.gNewCoupon.CODE}`).save({}, () => {
        alert($translate.instant('할인쿠폰이 등록되었습니다.', { code: $scope.gNewCoupon.CODE }));
        jQuery('#modal-g-add-coupon').modal('hide');
        $scope.gViewCoupon($rootScope.profileUser);
      }, alertApiErr);
    };
    $scope.gExtendCoupon = (coupon) => {
      const days = $window.prompt($translate.instant('쿠폰 연장 기간을 입력해주세요.\n- 만료날짜 기준으로 입력하신 일수 만큼 연장됩니다.'), '30');
      if (!coupon || !days || parseInt(days, 10) < 1) {
        return;
      }
      if (!$window.confirm($translate.instant('쿠폰을 연장하시겠습니까?'))) {
        return;
      }
      $resource(`${apiUrl()}/admin/coupons/${coupon.ID}/extension`).save({ DAYS: days }).$promise
        .then(() => {
          alert($translate.instant('연장되었습니다.'));
          $scope.gViewCoupon($rootScope.profileUser);
        })
        .catch(alertApiErr);
    };
    $scope.gDeleteCoupon = (coupon) => {
      if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
        return;
      }
      $resource(`${apiUrl()}/admin/coupons/:coupon_id`, { coupon_id: coupon.ID, isGroup: false }).delete(() => {
        alert($translate.instant('삭제되었습니다'));
        $scope.gCoupons.splice($scope.gCoupons.indexOf(coupon), 1);
      }, alertApiErr);
    };
    $scope.gEditCoupon = (coupon) => {
      let end = '';
      if (coupon.ENDDATE_UTC) {
        end = moment(coupon.ENDDATE_UTC).utc().format('YYYY-MM-DD');
      }
      $scope.gEditCouponForm = {
        ID: coupon.ID,
        CODE: coupon.CODE,
        PRICE: coupon.PRICE,
        ENDDATE: end,
        _ref: coupon,
      };
      jQuery('#modal-g-edit-coupon').modal('show');
    };
    $scope.gEditCouponSubmit = () => {
      const price = parseInt($scope.gEditCouponForm.PRICE, 10);
      if (Number.isNaN(price) || price < 0) {
        alert($translate.instant('금액을 입력해주세요.'));
        return;
      }
      if (!$scope.gEditCouponForm.ENDDATE) {
        alert($translate.instant('유효기간을 입력해주세요.'));
        return;
      }
      $resource(`${apiUrl()}/admin/coupons/${$scope.gEditCouponForm.ID}/modify`).save({
        PRICE: price,
        ENDDATE: $scope.gEditCouponForm.ENDDATE,
      }).$promise
        .then((data) => {
          alert($translate.instant('수정되었습니다.'));
          if ($scope.gEditCouponForm._ref) {
            $scope.gEditCouponForm._ref.PRICE = price;
            if (data.coupon && data.coupon.ENDDATE_UTC) {
              $scope.gEditCouponForm._ref.ENDDATE_UTC = data.coupon.ENDDATE_UTC;
            }
          }
          jQuery('#modal-g-edit-coupon').modal('hide');
        })
        .catch(alertApiErr);
    };
  });

angular.module('app').run(['$rootScope', '$location', '$resource', '$translate', '$cookies', 'AuthService', 'envService', function _($rootScope, $location, $resource, $translate, $cookies, AuthService, envService) {
  $rootScope.gShowEmployeeView = function gShowEmployeeView(tbUserId) {
    const APIURL = envService.read('apiUrl');
    if (!AuthService.isAuthenticated()) {
      $location.path('/login');
      return;
    }
    $resource(`${APIURL}/admin/employees/:tb_user_id`, { tb_user_id: tbUserId }).get((data) => {
      $rootScope.profileUser = data.employee;
      console.log($rootScope.profileUser);
      jQuery('#modal-employee-view').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $rootScope.gShowUserView = function gShowUserView(tbUserId) {
    const APIURL = envService.read('apiUrl');
    if (!AuthService.isAuthenticated()) {
      $location.path('/login');
      return;
    }
    $resource(`${APIURL}/admin/users/:tb_user_id`, { tb_user_id: tbUserId }).get((data) => {
      if (data.user.NAME === undefined) {
        $rootScope.profileUser = { NAME: $translate.instant('탈퇴한 회원입니다.') };
      } else {
        $rootScope.profileUser = data.user;
      }
      $rootScope.isUserOnPayOnSiteBlacklist = data.isUserOnPayOnSiteBlacklist;
      jQuery('#modal-duplicated-car-members').removeClass('fade');
      jQuery('#modal-duplicated-car-members').modal('hide');
      jQuery('#modal-user-view').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $rootScope.gShowUserViewByInvitationCode = function gShowUserViewByInvitationCode(invitationCode) {
    const APIURL = envService.read('apiUrl');
    if (!AuthService.isAuthenticated()) {
      $location.path('/login');
      return;
    }
    $resource(`${APIURL}/admin/users`, { }).get({ invitationCode }, (data) => {
      if (data.user.NAME === undefined) {
        $rootScope.profileUser = { NAME: $translate.instant('탈퇴한 회원입니다.') };
      } else {
        $rootScope.profileUser = data.user;
      }
      $rootScope.isUserOnPayOnSiteBlacklist = data.isUserOnPayOnSiteBlacklist;
      jQuery('#modal-duplicated-car-members').removeClass('fade');
      jQuery('#modal-duplicated-car-members').modal('hide');
      jQuery('#modal-user-view').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $rootScope.gShowOrderView = function gShowOrderView(orderNo) {
    const APIURL = envService.read('apiUrl');
    if (!AuthService.isAuthenticated()) {
      $location.path('/login');
      return;
    }
    if (!orderNo) {
      return;
    }
    $resource(`${APIURL}/admin/orders/${orderNo}`).get({}, (data) => {
      $rootScope.viewOrder = data.order;
      jQuery('#modal-view-order').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $rootScope.isCanceledOrder = (order) => {
    if (!order || !order.STATUS) { return false; }
    const status = parseInt(order.STATUS, 10);
    if (status >= 96 && status <= 99) {
      return true;
    }
    return false;
  };
  $rootScope.gLogout = function doLogout() {
    $cookies.remove('token');
    $cookies.remove('user');
    $location.path('/login');
  };
  $rootScope.paymentMethodName = (paymentMethod) => {
    switch (paymentMethod) {
      case '01':
        return '신용카드';
      case '02':
        return '휴대폰';
      case '03':
        return '결제 정보 없음';
      case '04':
        return '간편결제';
      case '05':
        return '카카오페이';
      case '06':
        return '현장결제';
      case '07':
        return '현장결제';
      case '08':
        return '현장결제 (현금)';
      case '09':
        return '현장결제 (카드)';
      case '10':
        return '간편결제 (등록한 카드로 결제)';
      case '11':
        return '정기세차';
      case '20':
        return '간편결제(GMO)';
      default:
        return '-';
    }
  };
  $rootScope.orderFunc = {};
  $rootScope.orderFunc.excludeRate = (order, excludeRate) => {
    const APIURL = envService.read('apiUrl');
    $resource(`${APIURL}/admin/orders/${order.ORDER_NO}/excludeRate`).save({ EXCLUDE_RATE: excludeRate }, () => {
      alert($translate.instant('수정되었습니다.'));
      order.RATE_EXCLUDE = excludeRate;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $rootScope.orderFunc.excludeWashCount = (order, excludeWashCountYn, excludeCashCountYn) => {
    const APIURL = envService.read('apiUrl');
    $resource(`${APIURL}/admin/orders/${order.ORDER_NO}/excludeWashCount`).save({ EXCLUDE_WASH_COUNT_YN: excludeWashCountYn, EXCLUDE_CASH_COUNT_YN: excludeCashCountYn }, () => {      
      alert($translate.instant('수정되었습니다.'));
      order.EXCLUDE_WASH_COUNT_YN = excludeWashCountYn;
      order.EXCLUDE_CASH_COUNT_YN = excludeCashCountYn;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };  
  const { gShowOrderView, gLogout, gShowUserView, gShowEmployeeView, paymentMethodName } = $rootScope;
  $rootScope.commonFunc = { gShowOrderView, gLogout, gShowUserView, gShowEmployeeView, paymentMethodName };
}]);



// WEBPACK FOOTER //
// ./src/app/app.ctrl.js